import { useEffect } from "react";

type Props = {
  currentStep?: number;
};

export const AccessibilityFocusManager = (props: Props) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const mainEl = document.querySelector("#root") as HTMLElement | null;
      if (mainEl) {
        mainEl.setAttribute("tabindex", "-1");
        mainEl.setAttribute("role", "main");
        mainEl.removeAttribute("aria-hidden");
        mainEl.focus();
        console.log("[A11y] Focus moved to main element");
        return;
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [props.currentStep]);

  return null;
};
